export const organisationStatus = {
  published: "Published",
  awaitingReview: "Awaiting review",
  awaitingReverification: "Awaiting reverification",
  draft: "Draft",
  rejected: "Rejected",
};
